import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

import ListCatalog from './containers/ListCatalog';

const routes = [
    {
        type: 'simple',
        name: 'list',
        view: ListCatalog,
        path: '/catalog'
    }
];

export default ModuleBootstrapper.getRoutes('catalog', routes);
